import { setAppTitle } from "./ui.helpers";
import { getDataFromStrapi } from "./initial-data";
import { EVENTS } from "../constants/events.constants";
import { LOCALES, allowedLangs } from "../constants/locales.constants";
export let lang = new URLSearchParams(location.search).get("lang") || LOCALES.RU;
if (!allowedLangs.includes(lang)) {
    lang = LOCALES.RU;
}
export function setLocaleListeners(context, locale) {
    setAppTitle();
    locale.lang = new URLSearchParams(location.search).get("lang") || lang;
    locale.beforeLangChange = async (newLang) => {
        const detail = await getDataFromStrapi(context, newLang);
        window.dispatchEvent(new CustomEvent(EVENTS.setProperties, { detail }));
    };
    locale.onLangChange = (newLang) => {
        if (allowedLangs.includes(newLang)) {
            lang = newLang;
        }
        setAppTitle();
    };
    return locale;
}
